import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { TruckIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import * as Styles from './styles'

const ParcelPickupDate = ({ date }) => {
  const { info } = useContext(AppContext)
  const { t, i18n } = useTranslation()

  if (!date) return null

  return (
    <Styles.Container>
      <TruckIcon size={24} />
      <Text type="bodyMRegular">{t('Recogida')}:</Text>
      <Text type="bodyMRegular">
        {new Intl.DateTimeFormat(i18n.language, {
          dateStyle: 'medium',
          timeZone: info?.selectedStore?.timezone,
        }).format(new Date(date))}
      </Text>
    </Styles.Container>
  )
}

export default ParcelPickupDate
